import React, { ReactNode, useMemo, useState } from 'react';
import { BrukerinfoDto } from '../api/generated/student-generated-api';

export interface StudentUserStore {
  studentUser: BrukerinfoDto | undefined;
  setStudentUser: (user: BrukerinfoDto) => void;
}

export const StudentUserContext = React.createContext<StudentUserStore>({
  studentUser: undefined,
  setStudentUser: () => {},
});

export const StudentUserProvider: React.FC<
  React.PropsWithChildren<{ children: ReactNode }>
> = ({ children }) => {
  const [studentUser, setStudentUser] = useState<BrukerinfoDto | undefined>();

  const userStore: StudentUserStore = useMemo(
    () => ({
      studentUser,
      setStudentUser,
    }),
    [studentUser],
  );

  return (
    <StudentUserContext.Provider value={userStore}>
      {children}
    </StudentUserContext.Provider>
  );
};
